import type { MenuProps } from 'antd';
import { OrderStatusTab } from '@/types/columns.ts';

/**
 * Items for the "…" menu of the orders bottom action bar (non-search view).
 * `menuItems[0]` is always Export.
 *
 * BOXY-394: Inventory used to get `[]`, so the "…" opened an empty dropdown and
 * Export was unreachable. Resend/Return are already buttons in the bar, so the
 * menu carries Export only.
 */
export function getBulkMenuItems(
  activeTab: OrderStatusTab,
  menuItems: NonNullable<MenuProps['items']>,
  shouldHaveSelectAll: boolean,
): MenuProps['items'] {
  if (activeTab === OrderStatusTab.INVENTORY) return menuItems.slice(0, 1);
  // On Hold always gets the full menu (Export + Bulk resolve CSV) — bug-fix round-3:
  // merchants could not find bulk-resolve from Problematic → Action Required.
  if (shouldHaveSelectAll || activeTab === OrderStatusTab.ON_HOLD) return menuItems;
  return menuItems.slice(0, 1);
}
